<template>
    <v-container fluid class="modal-container">
        <div class="mismaLinea">
            <div class="title">Editar asiento</div>
            <div class="d-flex ml-auto">
                <app-btn outlined @click="closeModal()">Cerrar</app-btn>
            </div>
        </div>
        <v-divider class="mt-4 full-width-divider"/>
        <v-tabs v-model="currentTab" class="main-tabs-full-width">
            <v-tab key="asiento">Asiento</v-tab>
            <v-tab key="asiento-pago">Asiento de pago</v-tab>
        </v-tabs>
        <v-tabs-items class="ma-0 pa-0" v-model="currentTab">
            <v-tab-item class="ma-0 pa-0" key="asiento">
              <div :class="screen_data && screen_data.analyticPlanPopup && screen_data.analyticPlanPopup.showPopup ? 'd-flex analytic-layout' : ''">
                <div 
                    v-if="account_move_lines && account_move_lines.length"
                    class="full-width-table main-table"
                    :style="screen_data && screen_data.analyticPlanPopup && screen_data.analyticPlanPopup.showPopup ? 'width:65%' : 'width:100%'">
                  <v-data-table
                    :headers="headers"
                    :items="account_move_lines"
                    class="elevation-0 compact-table"
                    hide-default-footer
                    :items-per-page="1000"
                    :fixed-header="false"
                    :disable-pagination="true"
                    :disable-sort="true"
                    item-key="id"
                  >
                    <template v-slot:item.account="{ item }">
                      <div ref="accountCell" :style="getCellStyle(item)" :class="['cell-wrapper', { 'plan-active': hasPlanActive(item) }]">
                        <DocTextField
                          label=""
                          :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                          :required="true"
                          @change="setForcedMove(true)"
                          @focus="onAccountFocus(item)"
                          @reset-items="onAccountBlur(item); resetItems()"
                          v-model="item.account"
                          :items="got_feature('feature_accounts_master') ? accounts : []"
                          @get-values="getValues"
                          :disabled="forcePayMoveEdit"
                        />
                      </div>
                    </template>

                    <template v-slot:item.description="{ item }">
                      <div ref="descriptionCell">
                        <DocTextField
                          label=""
                          v-model="item.description"
                          @change="setForcedMove(true)"
                          :required="true"
                          hide-details
                          :disabled="disableForEditMode || forcePayMoveEdit"
                        />
                      </div>
                    </template>

                    <template v-slot:item.debit="{ item }">
                      <div ref="debitCell" :style="getCellStyle(item)" :class="['cell-wrapper', { 'plan-active': hasPlanActive(item) }]">
                        <DocTextField
                          v-if="item.line_type == 'apunte'"
                          label=""
                          kind="number"
                          @change="onDebitCreditChange(item)"
                          :required="true"
                          v-model="item.debit"
                          :disabled="disableForEditMode || forcePayMoveEdit"
                        />
                      </div>
                    </template>

                    <template v-slot:item.credit="{ item }">
                      <div ref="creditCell" :style="getCellStyle(item)" :class="['cell-wrapper', { 'plan-active': hasPlanActive(item) }]">
                        <DocTextField
                          v-if="item.line_type == 'apunte'"
                          label=""
                          kind="number"
                          @change="onDebitCreditChange(item)"
                          :required="true"
                          v-model="item.credit"
                          :disabled="disableForEditMode || forcePayMoveEdit"
                        />
                      </div>
                    </template>

                    <template v-slot:item.type_iva="{ item }">
                      <div ref="typeIvaCell" :style="getCellStyle(item)" :class="['cell-wrapper', { 'plan-active': hasPlanActive(item) }]">
                        <DocTextField
                          v-if="currentCompany"
                          label=""
                          @change="setForcedMove(true)"
                          v-model="item.type_iva"
                          hide-details
                          :required="requiredTypeIvaLine(item)"
                          :disabled="disableForEditMode || forcePayMoveEdit"
                        />
                      </div>
                    </template>

                    <!-- :items="screen_data.company.plans" -->
                    
                    <template v-slot:item.plan_1="{ item }">
                      <div :style="Object.assign({}, getCellStyle(item, 'plan_1'), (getPlan1(account_move_lines.indexOf(item)) && getPlan1(account_move_lines.indexOf(item)).ui_error) ? {'background-color': '#ff9898'} : {})" :class="['cell-wrapper', { 'plan-active': hasPlan1Active(item) }]">
                        <div class="d-flex align-center" v-if="screen_data.company && screen_data.company.plans && screen_data.lines">
                          <v-select
                            :items="getPlansForItem(item)"
                            class="select-plan"
                            item-text="name"
                            return-object
                            hide-details
                            :disabled="disableForEditMode || forcePayMoveEdit"
                            :value="getPlan1(account_move_lines.indexOf(item))"
                            @change="val => setLinePlan1(item, val, account_move_lines.indexOf(item))"
                            dense
                            append-icon="mdi-chevron-down"
                            style="flex: 1"
                            :clearable="true"
                            @click:clear="setLinePlan1(item, null, account_move_lines.indexOf(item))"
                          />
                          <v-icon
                            small
                            color="var(--v-primary-base)"
                            class="plan-edit-icon"
                            @click="openAnalyticPlanEditorPlan1(account_move_lines.indexOf(item))"
                          >
                            mdi-pencil
                          </v-icon>
                        </div>
                      </div>
                    </template> 

                    <template v-slot:item.plan_2="{ item }">
                      <div :style="Object.assign({}, getCellStyle(item, 'plan_2'), (getPlan2(account_move_lines.indexOf(item)) && getPlan2(account_move_lines.indexOf(item)).ui_error) ? {'background-color': '#ff9898'} : {})" :class="['cell-wrapper', { 'plan-active': hasPlan2Active(item) }]">
                        <div class="d-flex align-center" v-if="screen_data.company && screen_data.company.plans && screen_data.lines">
                          <v-select
                            :items="getPlansForItem(item)"
                            class="select-plan"
                            item-text="name"
                            return-object
                            hide-details
                            :disabled="disableForEditMode || forcePayMoveEdit"
                            :value="getPlan2(account_move_lines.indexOf(item))"
                            @change="val => setLinePlan2(item, val, account_move_lines.indexOf(item))"
                            dense
                            append-icon="mdi-chevron-down"
                            style="flex: 1"
                            :clearable="true"
                            @click:clear="setLinePlan2(item, null, account_move_lines.indexOf(item))"
                          />
                          <v-icon
                            small
                            color="var(--v-primary-base)"
                            class="plan-edit-icon"
                            @click="openAnalyticPlanEditorPlan2(account_move_lines.indexOf(item))"
                          >
                            mdi-pencil
                          </v-icon>
                        </div>
                      </div>
                    </template>

                    <template v-slot:item.actions="{ item }">
                      <div class="all-center">
                        <v-btn
                          icon
                          @click="deleteScreenDataLine(account_move_lines.indexOf(item));deleteLine(account_move_lines.indexOf(item));setForcedMove(true);"
                          size="x-small"
                          :disabled="!currentDoc.forced_move || disableForEditMode || forcePayMoveEdit"
                        >
                          <img src="/invoices/delete_row.png" style="width: 11px; height: 13px;" />
                        </v-btn>
                      </div>
                    </template>

                    <template v-slot:body.append>
                      <tr class="total-row">
                        <td colspan="2" class="total-cell-description">
                          <div class="d-flex align-center justify-end total-cell-label fs-18 pr-2">Total</div>
                        </td>
                        <td ref="debitCell">
                          <div class="total-cell">{{totalDebit}}</div>
                        </td>
                        <td ref="creditCell">
                          <div class="total-cell">{{totalCredit}}</div>
                        </td>
                        <td class="total-cell-type-iva"></td>
                        <td v-if="got_feature('feature_analytic_lines')" class="total-cell-plan"></td>
                        <td v-if="got_feature('feature_analytic_lines')" class="total-cell-plan"></td>
                        <td class="total-cell-actions"></td>
                      </tr>
                    </template>

                  </v-data-table>
                  <div class="d-flex mt-2" style="width: fit-content;">
                    <template v-if="account_move">
                      <v-btn
                        v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                        class="btn-add-line-asiento"
                        @click="addLine();setForcedMove(true);addScreenDataLine();"
                        :disabled="disableForEditMode || forcePayMoveEdit"
                        outlined
                        dense
                      >
                        <v-icon left size="20">
                          mdi-plus
                        </v-icon>
                        Añadir línea
                      </v-btn>
                    </template>
                  </div>
                </div>
                <div class="full-width-table popup-table">
                  <div v-for="line in filteredLinesWithPlan1" :key="line.line_number">
                    <SelectAnalyticPlan
                      v-if="line.plan_1"
                      :key="line.line_number.toString()+'_plan_1_'+(line.plan_1.code || '')"
                      :plan="line.plan_1"
                      :showPercent="shouldShowPercent(line)"
                      :lineNumber="line.line_number + 1"
                      :accountCode="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].account : ''"
                      :company="screen_data.company"
                      planLabel="Plan 1"
                      :planName="line.plan_1 && line.plan_1.name ? line.plan_1.name : ''"
                      :debit="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].debit : '0'"
                      :credit="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].credit : '0'"
                    ></SelectAnalyticPlan>
                  </div>
                  <div v-for="line in filteredLinesWithPlan2" :key="line.line_number">
                    <SelectAnalyticPlan
                      v-if="line.plan_2"
                      :key="line.line_number.toString()+'_plan_2_'+(line.plan_2.code || '')"
                      :plan="line.plan_2"
                      :showPercent="shouldShowPercent(line)"
                      :lineNumber="line.line_number + 1"
                      :accountCode="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].account : ''"
                      :company="screen_data.company"
                      planLabel="Plan 2"
                      :planName="line.plan_2 && line.plan_2.name ? line.plan_2.name : ''"
                      :debit="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].debit : '0'"
                      :credit="account_move_lines[line.line_number] && account_move_lines[line.line_number].account ? account_move_lines[line.line_number].credit : '0'"
                    ></SelectAnalyticPlan>
                  </div>
                </div>
              </div>
            </v-tab-item>
            <v-tab-item class="ma-0 pa-0 pt-4" key="asiento-pago">
              <div v-if="paid_account_move_lines.length==0">
                <v-row>
                  <v-col cols="2" class="pt-0 pb-1 text-left" v-if="account_move">
                    <v-btn 
                      v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                      class="btn-add-line-asiento"                  
                      @click="addPaidLine"
                      :disabled="disableForEditMode || forcePayMoveEdit"
                      outlined
                      dense
                      >
                      <v-icon left>
                        mdi-plus
                      </v-icon>
                      Añadir línea
                    </v-btn>                  
                  </v-col>
                </v-row>
                <div class="pt-3">
                    <v-alert prominent text type="success" class="fs-12">No se han creado Asientos del tipo indicado</v-alert>
                </div>
              </div>
              <div v-else>
                <div v-if="paid_account_move_lines && paid_account_move_lines.length">
                  <div class="full-width-table">
                    <v-row class="table-header">
                      <v-col cols="2" class="table-head">Cuenta</v-col>
                      <v-col cols="4" class="table-head">Descripción</v-col>
                      <v-col cols="2" class="table-head">Deber</v-col>
                      <v-col cols="2" class="table-head">Haber</v-col>
                      <v-col cols="1" class="table-head">T.Imp.</v-col>
                      <v-col cols="1" class="all-center"></v-col>
                    </v-row>
                    <!--  Pintamos, aquí los movimientos relacionados -->
                    <v-row   class="table-row" v-for="(paid_move, index) in paid_account_move_lines" v-bind:key="index">
                      <v-col cols="2" class="table-head">
                          <DocTextField
                            label="" 
                            :kind="got_feature('feature_accounts_master') ? 'account_am' : 'account'"
                            :required="true"
                            v-model="paid_move.account"
                            :class="{
                              invalid:currentDoc && !paid_move.account,
                            }"
                            :items="got_feature('feature_accounts_master') ? accounts : []"
                            @get-values="getValues"
                            @reset-items="resetItems"
                            class="activate-text"
                            :disabled="forcePayMoveEdit"
                          ></DocTextField>
                        </v-col>           
                        <v-col cols="4" class="table-head">
                          <DocTextField 
                            label="" 
                            v-model="paid_move.description" 
                            :required="true"
                            hide-details
                            class="activate-text"
                            :disabled="disableForEditMode || forcePayMoveEdit"
                          ></DocTextField>
                        </v-col>
                        <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'">
                          <DocTextField
                            label="" 
                            kind="number"
                            :required="true"
                            v-model="paid_move.debit" 
                            class="activate-text"
                            :disabled="disableForEditMode || forcePayMoveEdit"
                          ></DocTextField>
                        </v-col>
                        <v-col cols="2" class="table-head" v-if="paid_move.line_type == 'apunte'">
                          <DocTextField
                            label="" 
                            kind="number"
                            :required="true"
                            v-model="paid_move.credit" 
                            class="activate-text"
                            :disabled="disableForEditMode || forcePayMoveEdit"
                          ></DocTextField>
                          
                        </v-col>
                        <v-col cols="1" class="table-head">
                          <DocTextField 
                            v-if="currentCompany" 
                            label="" 
                            v-model="paid_move.type_iva"
                            hide-details
                            :required="requiredTypeIvaLine(paid_move)"
                            class="activate-text"
                            :disabled="disableForEditMode || forcePayMoveEdit"
                          ></DocTextField>
                        </v-col>
                        <v-col cols="1" class="all-center">
                          <v-btn icon color="primary" @click="deletePaidLine(index)" :disabled="disableForEditMode || forcePayMoveEdit">
                            <img src="/invoices/delete_row.png" style="width: 12px; height: 14px;"/>
                          </v-btn>
                        </v-col>
                    </v-row>
        
                    <div class="table-total-row d-flex align-center px-0 mt-2">
                      <div style="width: 16.66%;">
                        <template v-if="account_move">
                          <v-btn
                            v-if="!['done','done_manually','done_with_warning','pending_connect'].includes(currentDoc.state)"
                            class="btn-add-line-asiento"
                            @click="addPaidLine"
                            :disabled="disableForEditMode || forcePayMoveEdit"
                            outlined
                            dense
                          >
                            <v-icon left>
                              mdi-plus
                            </v-icon>
                            Añadir línea
                          </v-btn>
                        </template>
                      </div>
                      <div style="width: 33.33%;" class="d-flex align-center justify-end total-cell-label fs-18 pr-2">Total</div>
                      <div style="width: 16.66%;" class="px-1 total-cell">{{ totalDebitPaid }}</div>
                      <div style="width: 16.66%;" class="px-1 total-cell">{{ totalCreditPaid }}</div>
                      <div style="width: 16.66%;"></div>
                    </div>
                  </div>
                </div>
              </div>
            </v-tab-item>
        </v-tabs-items>

        <!-- Account Change Confirmation Dialog -->
        <v-dialog v-model="showAccountChangeDialog" max-width="500">
            <v-card>
                <v-card-title class="headline">
                    Cambiar cuenta
                </v-card-title>
                <v-card-text>
                    <p>¿Vas a cambiar la cuenta?</p>
                    <p>
                        <strong>Cuenta anterior:</strong> {{ pendingAccountChange ? pendingAccountChange.oldValue : '' }}
                    </p>
                    <p>
                        <strong>Cuenta nueva:</strong> {{ pendingAccountChange ? pendingAccountChange.newValue : '' }}
                    </p>
                    <div v-if="getAccountPredefinedPlans().length > 0">
                        <v-divider class="my-2"></v-divider>
                        <p class="mb-1"><strong>Esta cuenta tiene planes analíticos predefinidos:</strong></p>
                        <ul>
                            <li v-for="plan in getAccountPredefinedPlans()" :key="plan.code">
                                {{ plan.name }} ({{ plan.code }})
                            </li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="cancelAccountChange">
                        Cancelar
                    </v-btn>
                    <v-btn color="primary" text @click="confirmAccountChange">
                        Continuar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>

<script>
import AppBtn from '@/components/layout/AppBtn.vue';
import { createHelpers ,mapFields} from 'vuex-map-fields';
import { mapGetters,mapActions, mapState, mapMutations} from "vuex"
import DocTextField from "../components/DocTextField.vue";
import {round} from '../utils'
import {evaluate} from 'mathjs'
import { VueAnalyticPlanEditorScreenData } from "@/modules/analitic_accounting/infra/VueAnalyticsPlanEditorScreenData";
import { AnalyticPlanEditorComponent } from "@/modules/analitic_accounting/application/AnalyticsPlanEditorComponent";
import { ApiCompanyRepository } from "@/modules/analitic_accounting/infra/ApiCompanyRepository"
import SelectAnalyticPlan from "@/modules/analitic_accounting/infra/SelectAnalyticPlan.vue";
import { Line } from '@/modules/analitic_accounting/domain/Company';
import { canEditAccountsOnly } from '@/modules/invoices/domain/Invoice';
import { VueFeatureRepository } from '@/modules/shared/infra/FeatureRepository';

const { mapMultiRowFields } = createHelpers({
  getterType: 'documents/getAccountMoveField',
  mutationType: 'documents/updateAccountMoveField',
});

export default {
    components: {
        DocTextField,
        AppBtn,
        SelectAnalyticPlan
    },
    data(){
        const screen_data = new VueAnalyticPlanEditorScreenData();
        return {
            currentTab: 'asiento',
            showModal: false,
            headers: [
              {text: 'Cuenta', value: 'account', width: '8%'},
              {text: 'Descripción', value: 'description', width: '40%'},
              {text: 'Debe', value: 'debit', width: '6%'},
              {text: 'Haber', value: 'credit', width: '6%'},
              {text: 'T. Imp.', value: 'type_iva', width: '5%'},
              {text: '', value: 'actions', width: '5%'}
            ],
            screen_data: screen_data,
            analytic_plans_component:null,
            oldAccountValue: null,
            showAccountChangeDialog: false,
            pendingAccountChange: null,
            edit_only_accounts: false
        };
    },
    async mounted(){
        if (this.currentDoc && this.currentDoc.static_invoice) {
          let feature_repo = new VueFeatureRepository(this.got_feature);
          let accountsOnlyMessage = canEditAccountsOnly(this.currentDoc, this.currentDoc, feature_repo);
          if (!accountsOnlyMessage) {
            this.edit_only_accounts = true;
          }
        }
        
        if(this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.value==='sage_addon' && this.got_feature('feature_analytic_lines')) {
          let company_repo = new ApiCompanyRepository()
          this.analytic_plans_component = new AnalyticPlanEditorComponent(company_repo, this.screen_data)
          console.log("blackraven - EditAccounting.vue - mounted: ", this.account_move_lines)
          await this.analytic_plans_component.mountEditorComponent(this.currentDoc.companydb, this.account_move_lines)
          const newHeaders = [
            { text: 'Plan 1', value: 'plan_1', width: '10%'},
            { text: 'Plan 2', value: 'plan_2', width: '10%'},
          ];
          const index = this.headers.findIndex(h => h.value === 'actions');
          this.headers.splice(index, 0, ...newHeaders);
          console.log("---", this.account_move_lines)
        }
    },
    computed: {
        ...mapMultiRowFields(['account_move_lines', 'paid_account_move_lines']),
        ...mapGetters({
            got_feature:'got_feature',
            currentDoc: 'documents/currentDocument',
        }),
        ...mapFields('cru', ['accounts']),
        ...mapState([
            'currentCompany'
        ]),
        filteredLinesWithPlan1() {
            return this.screen_data && this.screen_data.lines
                ? this.screen_data.lines.filter(l => l.ui_show_plan_1 && l.plan_1)
                : [];
        },
        filteredLinesWithPlan2() {
            return this.screen_data && this.screen_data.lines
                ? this.screen_data.lines.filter(l => l.ui_show_plan_2 && l.plan_2)
                : [];
        },
        account_move(){
            return (this.currentDoc && this.currentDoc.accountMoves.length)?this.currentDoc.accountMoves[0]:undefined
        },
        totalDebit(){
            try{
              if(this.account_move){
                return round(this.account_move_lines.map(x=>x.debit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
        },
        totalDebitPaid(){
            try{
              if(this.paid_account_move_lines){
                return round(this.paid_account_move_lines.map(x => x.debit).reduce((x,y)=> this.num(x) + this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
        },
        totalCredit(){
            try{
              if(this.account_move){
                return round(this.account_move_lines.map(x=>x.credit).reduce((x,y)=>this.num(x)+this.num(y),0))
              }
            }catch(err){
              console.error(err)
            }
            return 0
        },
        totalCreditPaid(){
            try
            {
              if(this.paid_account_move_lines) {
                return round(this.paid_account_move_lines.map(x => x.credit).reduce((x,y) => this.num(x) + this.num(y),0))
              }
            } catch(err) {
              console.error(err)
            }
            return 0
        },
        balance(){
            return round(this.totalDebit-this.totalCredit)
        },
        balancePaid(){
            return round(this.totalDebitPaid-this.totalCreditPaid)
        },
        paid_account_move(){
            return (this.currentDoc && this.currentDoc.accountMoves.length
              && this.currentDoc.accountMoves[0].paid_account_move && this.currentDoc.accountMoves[0].paid_account_move.length
            )
              ? this.currentDoc.accountMoves[0].paid_account_move[0] : undefined
        },
        paid_account_move_lines(){
            try
              {
                return (this.currentDoc && this.currentDoc.accountMoves.length
                  && this.currentDoc.accountMoves[0].paid_account_move
                  && this.currentDoc.accountMoves[0].paid_account_move.length > 0
                  && this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines
                  ) ? this.currentDoc.accountMoves[0].paid_account_move[0].account_move_lines : []
              } catch(err){
                console.error(err)
              }
            return undefined
        },
        forcePayMoveEdit() {
          if(this.currentDoc.prorate && this.got_feature('feature_editar_asiento_pago')) {
            return true
          }
          return false
        },
        disableForEditMode() {
          // Para eFacturas con edit_only_accounts, los campos (excepto account) deben estar deshabilitados
          return this.edit_only_accounts;
        },
        computedWidth() {
          if (this.screen_data && this.screen_data.analyticPlanPopup && this.screen_data.analyticPlanPopup.showPopup) {
            return 'with: 70% !important;';
          } else {
            return 'width: 100% !important;';
          }
        }
    },
    methods: {
        onAccountFocus(item) {
            // Store the current account value when user focuses
            this.oldAccountValue = item.account;
        },
        onAccountBlur(item) {
            // Prevent duplicate dialogs (e.g., when Enter key triggers multiple events)
            if (this.showAccountChangeDialog) {
                return;
            }

            // Only show dialog if:
            // 1. The value changed
            // 2. Analytics are enabled (is_analytic_plan is true)
            // 3. The new account has predefined plans
            const analyticsEnabled = this.screen_data &&
                                     this.screen_data.company &&
                                     this.screen_data.company.analytics_plan_configuration &&
                                     this.screen_data.company.analytics_plan_configuration.is_analytic_plan;

            if (this.oldAccountValue !== item.account && analyticsEnabled && this.analytic_plans_component) {
                // Check if new account has predefined plans
                const newAccountPlans = this.analytic_plans_component.getPlansForAccount({ account: item.account });

                // Only show dialog if the new account has predefined plans
                if (newAccountPlans.length > 0) {
                    this.pendingAccountChange = {
                        item: item,
                        oldValue: this.oldAccountValue,
                        newValue: item.account
                    };
                    // Temporarily restore old value until user confirms
                    item.account = this.oldAccountValue;
                    this.showAccountChangeDialog = true;
                }
            }
        },
        confirmAccountChange() {
            if (this.pendingAccountChange && this.analytic_plans_component) {
                const item = this.pendingAccountChange.item;

                // Apply the new account value
                item.account = this.pendingAccountChange.newValue;

                // Find the line in screen_data
                const lineIndex = this.account_move_lines.indexOf(item);
                if (lineIndex !== -1 && this.screen_data && this.screen_data.lines && this.screen_data.lines[lineIndex]) {
                    const line = this.screen_data.lines[lineIndex];

                    // IMPORTANT: Update line.account to match the new account
                    // This is critical for account_plans_contains check in assignAnalyticPlanToLinePlan
                    line.account = this.pendingAccountChange.newValue;

                    // Get the new account's predefined plans (only explicit plans, not company.plans)
                    const newAccountPlans = this.analytic_plans_component.getPlansForAccount(item);

                    // Check if we should keep old plans when new account has no predefined plans
                    const company = this.screen_data.company;
                    const allowAllAccounts = company && company.analytics_plan_configuration && company.analytics_plan_configuration.is_allow_analytics_plans_all_accounts || false;

                    // Get debit and credit values
                    const debit = parseFloat(item.debit) || 0;
                    const credit = parseFloat(item.credit) || 0;

                    // Hide any currently displayed plans in the right panel
                    // This ensures the old plan display is closed before assigning the new one
                    line.ui_show_plan_1 = false;
                    line.ui_show_plan_2 = false;

                    // Handle plan_1
                    if (newAccountPlans.length >= 1) {
                        // New account has predefined plans -> assign them
                        this.analytic_plans_component.assignAnalyticPlanToLinePlan1(line, newAccountPlans[0], debit, credit);
                    } else {
                        // New account has NO predefined plans
                        if (!allowAllAccounts) {
                            // is_allow_analytics_plans_all_accounts is false -> clear the plan
                            this.analytic_plans_component.assignAnalyticPlanToLinePlan1(line, null, debit, credit);
                        }
                        // If allowAllAccounts is true -> keep the old plan (do nothing)
                    }

                    // Handle plan_2
                    if (newAccountPlans.length >= 2) {
                        // New account has 2+ predefined plans -> assign the second one
                        this.analytic_plans_component.assignAnalyticPlanToLinePlan2(line, newAccountPlans[1], debit, credit);
                    } else if (newAccountPlans.length === 1) {
                        // New account has only 1 predefined plan -> clear plan_2
                        this.analytic_plans_component.assignAnalyticPlanToLinePlan2(line, null, debit, credit);
                    } else {
                        // New account has NO predefined plans
                        if (!allowAllAccounts) {
                            // is_allow_analytics_plans_all_accounts is false -> clear the plan
                            this.analytic_plans_component.assignAnalyticPlanToLinePlan2(line, null, debit, credit);
                        }
                        // If allowAllAccounts is true -> keep the old plan (do nothing)
                    }
                }

                this.setForcedMove(true);
            }
            this.showAccountChangeDialog = false;
            this.pendingAccountChange = null;
        },
        cancelAccountChange() {
            // Keep the old value (already restored in onAccountBlur)
            this.showAccountChangeDialog = false;
            this.pendingAccountChange = null;
        },
        getAccountPredefinedPlans() {
            if (!this.pendingAccountChange || !this.analytic_plans_component) {
                return [];
            }
            const tempItem = { account: this.pendingAccountChange.newValue };
            return this.analytic_plans_component.getPlansForAccount(tempItem);
        },
        ...mapMutations({
            addLine:'documents/addLine',
            addPaidLine: 'documents/addPaidLine',
            deleteLine:'documents/deleteLine',
            deletePaidLine: 'documents/deletePaidLine',
        }),
        ...mapActions({
          setForcedMove: "documents/setForcedMove",
          setLineAnalyticPlanUdated: "documents/setLineAnalyticPlanUdated"
        }),
        ...mapActions("cru", ['getAccounts']),
        hasPlanActive(item) {
          const index = this.account_move_lines.indexOf(item);
          if (index !== -1 && this.screen_data && this.screen_data.lines && this.screen_data.lines[index]) {
            const line = this.screen_data.lines[index];
            return (line.ui_show_plan_1 && line.plan_1) || (line.ui_show_plan_2 && line.plan_2);
          }
          return false;
        },
        hasPlan1Active(item) {
          const index = this.account_move_lines.indexOf(item);
          if (index !== -1 && this.screen_data && this.screen_data.lines && this.screen_data.lines[index]) {
            const line = this.screen_data.lines[index];
            return line.ui_show_plan_1 && line.plan_1;
          }
          return false;
        },
        hasPlan2Active(item) {
          const index = this.account_move_lines.indexOf(item);
          if (index !== -1 && this.screen_data && this.screen_data.lines && this.screen_data.lines[index]) {
            const line = this.screen_data.lines[index];
            return line.ui_show_plan_2 && line.plan_2;
          }
          return false;
        },
        getCellStyle(item, checkPlan = null) {
          // If checking a specific plan, verify only that plan is active
          let isActive = false;
          if (checkPlan === 'plan_1') {
            isActive = this.hasPlan1Active(item);
          } else if (checkPlan === 'plan_2') {
            isActive = this.hasPlan2Active(item);
          } else {
            isActive = this.hasPlanActive(item);
          }

          if (!isActive) return {};

          // Always apply purple background when plan is active, regardless of errors
          return { 'background-color': '#F2EBFC' };
        },
        closeModal() {
          console.log("blackraven - EditAccounting.vue - closeModal 01 - screen_data.lines: ", this.screen_data.lines);
          console.log("blackraven - EditAccounting.vue - closeModal 01 - account_move_lines: ", this.account_move_lines);

          for(let i=0;i<this.screen_data.lines.length;i++){
            // Validate if plan_1 exists AND has the method to_primitive before calling it
            if(this.screen_data.lines[i].plan_1 && typeof this.screen_data.lines[i].plan_1.to_primitive === 'function')
              this.account_move_lines[i].plan_1 = this.screen_data.lines[i].plan_1.to_primitive()
            else
              this.account_move_lines[i].plan_1 = {}
            // Apply the same logic for plan_2
            if(this.screen_data.lines[i].plan_2 && typeof this.screen_data.lines[i].plan_2.to_primitive === 'function')
              this.account_move_lines[i].plan_2 = this.screen_data.lines[i].plan_2.to_primitive()
            else
              this.account_move_lines[i].plan_2 = {}
            
          }

          console.log("blackraven - EditAccounting.vue - closeModal 02 - screen_data.lines: ", this.screen_data.lines);
          console.log("blackraven - EditAccounting.vue - closeModal 02 - account_move_lines: ", this.account_move_lines);
          
          this.$emit("close-modal", true);
        },
        getValues(params) {
            this.getAccounts(params).then(() => {});
        },
        resetItems(params) {
            this.accounts = params;
        },
        requiredTypeIvaLine(line) {
            return this.currentDoc && line && line.account && (line.account.startsWith('472') || line.account.startsWith('477')) && !line.type_iva && !((this.currentDoc.iva_parcial || this.currentDoc.gasto_iva_parcial) && this.currentCompany && this.currentCompany.companydb_type && this.currentCompany.companydb_type.params.hasOwnProperty('allow_account_exc_expens_lines_no_IVA') && line.account.startsWith(this.currentCompany.companydb_type.params['allow_account_exc_expens_lines_no_IVA']));
          },
        num(x){
            if (x==='') {
                return 0;
            }else{
                return evaluate(x);
            }
        },
        openAnalyticPlanEditorPlan1(index) {
          console.log("blackraven - EditAccounting.ts - openAnalyticPlanEditorPlan1: ", index);
          this.analytic_plans_component.show_plan_1(index);
        },
        openAnalyticPlanEditorPlan2(index) {
          console.log("blackraven - EditAccounting.ts - openAnalyticPlanEditorPlan2: ", index);
          this.analytic_plans_component.show_plan_2(index);
        },
        setLinePlan1(line, analitic_plan, index) {
          //let l = this.screen_data.lines.find(e=>e.id==line.id)
          console.log("blackraven - EditAccounting.vue - setLinePlan1 01: ", index, line);
          let l = this.screen_data.lines[index];
          console.log("blackraven - EditAccounting.vue - setLinePlan1 02: ", index, l);
          const debit = this.num(line.debit);
          const credit = this.num(line.credit);
          this.analytic_plans_component.assignAnalyticPlanToLinePlan1(l, analitic_plan, debit, credit);
          this.setLineAnalyticPlanUdated(true);

          // If changed, is force to reload the analytic plan form again.
          l.ui_show_plan_1 = false
        },
        setLinePlan2(line, analitic_plan, index) {
          console.log("blackraven - EditAccounting.vue - setLinePlan2 01: ", index, line);
          let l = this.screen_data.lines[index];
          console.log("blackraven - EditAccounting.vue - setLinePlan2 02: ", index, l);
          const debit = this.num(line.debit);
          const credit = this.num(line.credit);
          this.analytic_plans_component.assignAnalyticPlanToLinePlan2(l, analitic_plan, debit, credit);
          this.setLineAnalyticPlanUdated(true);

          // If changed, is force to reload the analytic plan form again.
          l.ui_show_plan_2 = false
        },
        getPlansForItem(item) {
          return this.analytic_plans_component.getPlansForItem(item);
        },
        getPlan1(index) {
          const line = this.screen_data.lines[index];
          return line ? line.plan_1 : null; // returns null if not found
        },
        getPlan2(index) {
          const line = this.screen_data.lines[index];
          return line ? line.plan_2 : null; // returns null if not found
        },
        addScreenDataLine(){
          console.log("blackraven - EditAccounting.vue - addScreenDataLine 01: ", this.screen_data.lines);
          const account_move_line = this.account_move_lines[this.account_move_lines.length - 1];
          let screen_line = new Line(account_move_line.id, account_move_line.plan_1, account_move_line.plan_2, this.screen_data.lines.length);
          this.screen_data.lines.push(screen_line);
          console.log("blackraven - EditAccounting.vue - addScreenDataLine 02: ", this.screen_data.lines);
        },
        deleteScreenDataLine(index){
          console.log("blackraven - EditAccounting.vue - deleteScreenDataLine 01: ", index, this.screen_data.lines);
          this.screen_data.lines.splice(index,1);
          this.screen_data.reCountLines();
          console.log("blackraven - EditAccounting.vue - deleteScreenDataLine 02: ", index, this.screen_data.lines);
        },
        shouldShowPercent(line) {
          if (!this.screen_data.company) {
            return false;
          }

          // Get the account from account_move_lines
          const accountMoveLine = this.account_move_lines[line.line_number];
          const accountCode = accountMoveLine ? accountMoveLine.account : null;

          // Use domain logic to determine if percent should be shown
          return this.screen_data.company.shouldShowPercentForAccount(accountCode);
        },
        onDebitCreditChange(item) {
          this.setForcedMove(true);

          // Update analytic plan amounts if they exist
          if (this.analytic_plans_component) {
            const index = this.account_move_lines.indexOf(item);
            const debit = this.num(item.debit);
            const credit = this.num(item.credit);
            this.analytic_plans_component.updateLineAmount(index, debit, credit);
          }
        },
    },
}

</script>

<style scoped>

.all-center {
    display:flex;
    justify-content: center;
    align-items: center;
    padding: 0px;
}

.table-col {
    padding-bottom: 10px !important;
}
.table-total{
    color: black;
    font-weight: 400;
    height: 4vw;
    margin-top:8px;
    align-items: center;
    padding-left: 2.8vw;
    padding-right: 2.8vw;
}
.table-body{
    color: black;
    font-weight: 400;
    border-bottom: 1px solid black;
    border-left: 1px solid black;
    border-right: 1px solid black;
    height: 4vw;
}
.table-header{
  border-right-style: solid;
  border-left-style: solid;
  border-bottom-style: solid;
  border-top-style: solid;
  border-color: #D9D9D9;
  border-width: thin;
  font-size:16px;
  background-color: #D9D9D9;
  color:#6D6D6D;
  font-weight: bold;
  line-height: 40px;
  text-align: center;
}
.full-width-table.main-table {
    padding-top: 0;
    padding-left: 0;
    padding-right: 0;
  }
  .full-width-table {
    padding-top: 2vw;
    padding-left: 1vw;
    padding-right: 1vw;
  }
  /*width: 70% !important;*/
.mismaLinea {
    display: flex;
    align-items: center;
}
.title-tabs {
    padding-bottom: 0px;
}
.items-tabs {
    margin-top: 0px !important;
}
::v-deep .v-tabs-bar__content {
    background: #F8F8FA;
}
.v-tab {
    text-transform: capitalize !important;
    font-weight: 400;
    font-size: 18px;
}

/* Full width background for main tabs only */
.main-tabs-full-width {
    margin-left: -2.8vw !important;
    margin-right: -2.8vw !important;
    width: calc(100% + 5.6vw) !important;
}

/* Ensure the tabs bar extends full width */
::v-deep .main-tabs-full-width .v-tabs-bar {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
}

/* Ensure the tabs bar content extends full width with background */
::v-deep .main-tabs-full-width .v-tabs-bar__content {
    background: #F8F8FA !important;
    margin-left: 0 !important;
    margin-right: 0 !important;
    padding-left: 2.8vw !important;
    padding-right: 2.8vw !important;
    width: 100% !important;
}

/* Full width divider */
.full-width-divider {
    margin-left: -2.8vw !important;
    margin-right: -2.8vw !important;
    width: calc(100% + 5.6vw) !important;
    max-width: none !important;
}

::v-deep .full-width-divider hr {
    margin-left: 0 !important;
    margin-right: 0 !important;
    width: 100% !important;
    max-width: none !important;
}

.modal-container {
    padding-left: 2.8vw !important;
    padding-right: 2.8vw !important;
    padding-top: 1.8vw !important;
    padding-bottom: 1.8vw !important;
}
.title{
    color: var(--v-primary-base);
    font-size: 1.8vw !important;
    font-weight: bold;
}

.primary-bckground {
    background-color: var(--v-primary-base);
}
.primary-border {
    border-color: var(--v-primary-base) !important;
}

.checkbox-col {
    height:90px; 
}

.table-row{
    border-right-style: solid;
    border-left-style: solid;
    border-bottom-style: solid;
    border-color: #D9D9D9;
    border-width: thin;
    line-height: 10px !important;
}

.table-head {
    border-left-style:solid;
    border-right-style:solid;
    border-color:#D9D9D9;
    border-width: thin;
    padding: 0px !important;
}

/* Make DocTextField fill entire cell height in table-head */
.table-head .v-input {
    height: 100%;
}

.table-head .v-input__control {
    height: 100%;
}

.table-head .v-input__slot {
    height: 100%;
    min-height: 40px;
}
.custom_col_2_4 {
    max-width: 19.99999%;
    flex-basis:19.99999%;
}
.custom_col_4_4 {
    max-width: 36.66666%;
    flex-basis:36.66666%;
}
.custom_col_0_6 {
    max-width: 5%;
    flex-basis: 5%;
}
.btn-add-line-asiento {
  width: 100%;
  border-radius:2px;
  text-transform: none;
  border-color: #B0B0B0;
  font-size:15px;
  font-weight: 500;
  color:#454545;
  letter-spacing:normal;
  line-height: 30px;
}
.total-cell-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--v-primary-base);
    font-weight: bold;
}
.fs-18 {
    font-size: 18px;
}
.total-cell {
    box-sizing: border-box;
    border: none;
    line-height: 1.5;
    border-radius: 2px;
    font-size: 14px;
    color: var(--v-primary-base);
    font-weight: 600;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    padding: 0 8px !important;
}

/* Styles for total row inside table */
.total-row {
  background-color: transparent !important;
}

.total-row td {
  height: auto !important;
  vertical-align: middle !important;
}

/* Remove border-right from columns after Haber in total row only */
.total-row td:nth-child(n+4) {
  border-right: none !important;
}

.total-cell-description {
  text-align: right !important;
}

.table-head {
  border-left-style:solid;
  border-right-style:solid;
  border-color:#D9D9D9;
  border-width: thin;
}
.table-right-head {
  border-right-style:solid;
  border-color:#D9D9D9;
  border-width: thin;
}

  /* Select invoice */
  .select-plan {
    font-size: 12px;
    border-radius: 2px; 
    padding: 0px !important;
    min-width: 100px !important;
  }

  .select-plan >>> fieldset {
    border-color: #B0B0B0;
  }

  .select-plan >>> .v-input__prepend-outer {
    margin-top: 2px !important;
    text-wrap: nowrap;
    white-space: nowrap;
  }

  .select-plan label {
    color: #454545;
    line-height: 20px;
    font-weight: 600;
    font-family: "Roboto"; 
  }

  .select-plan >>> .v-input__slot {
    min-height: 15px !important;
    padding-left: 6px !important;
    padding-right: 5px !important;
  }

  .select-plan >>> input {
    padding: 0px !important;
    line-height: 25px;
    font-weight: 300;
  }

  .select-plan >>> .v-input__append-inner {
    margin-top: 1px !important;
    padding-left: 2px;
  }

  .select-plan >>> .v-input__icon {
    width: 22px;
    height: 22px;
    max-width: 22px;
    min-width: 22px;
  }

  .select-plan >>> .v-input__icon .v-icon {
    font-size: 18px;
  }

  .select-plan >>> .v-select__selection--comma {
    margin: 0px;      
  }

  .select-plan >>> .v-select__selections {
    padding: 0px !important;
    font-weight: 300;
  }

  .select-plan >>> .v-text-field__details {
    margin-bottom: 4px;
  }

  .select-plan >>> .v-text-field__details,
  .select-plan >>> .v-messages {
    min-height: 0px;
    font-size: 10px;
  }
  
  .select-plan.v-input--is-disabled, 
  .select-plan.v-input--is-readonly {
    border-radius: 20px !important;
  }

  .analytic-layout {
    width: 100%;
    display: flex;
    flex-direction: row;
  }

  .analytic-layout .main-table {
    transition: width 0.2s;
  }

  .analytic-layout .popup-table {
    transition: width 0.2s;
  }

  .plan-info-badge {
    background-color: #F2EBFC;
    color: var(--v-primary-base);
    padding: 6px 12px;
    border-radius: 6px;
    display: inline-block;
    margin: 4px 6px 4px 0;
  }

  .cell-wrapper {
    width: 100%;
    height: 100%;
    padding: 4px;
  }

  /* Table styling */
  ::v-deep .compact-table {
    border: 1px solid #D9D9D9 !important;
    border-top-left-radius: 2px !important;
    border-top-right-radius: 2px !important;
  }

  /* Remove gap between tabs and table */
  ::v-deep .v-tabs-items {
    margin-top: -1px !important;
  }

  ::v-deep .compact-table tbody tr td {
    border-right: 1px solid #D9D9D9 !important;
    border-bottom: 1px solid #D9D9D9 !important;
  }

  /* Remove border-right from Plan 2 column (second to last) and last column (actions) */
  ::v-deep .compact-table tbody tr td:nth-last-child(2),
  ::v-deep .compact-table tbody tr td:last-child {
    border-right: none !important;
  }

  /* Reduce padding and min-width in account column (first data column) */
  ::v-deep .compact-table .v-data-table-header th:nth-child(1),
  ::v-deep .compact-table .v-data-table__wrapper td:nth-child(1) {
    min-width: auto !important;
  }

  ::v-deep .compact-table tbody tr td:first-child {
    padding: 0 !important;
  }

  ::v-deep .compact-table tbody tr td:first-child .cell-wrapper {
    padding: 0 !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }

  ::v-deep .compact-table tbody tr td:first-child .v-input {
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
  }

  ::v-deep .compact-table tbody tr td:first-child .v-input__slot {
    padding: 4px !important;
    height: 100% !important;
    min-height: 100% !important;
  }

  ::v-deep .compact-table tbody tr td:first-child .v-input__control {
    height: 100% !important;
  }

  ::v-deep .compact-table tbody tr td:first-child input {
    padding: 4px !important;
  }

  ::v-deep .compact-table thead th:first-child {
    padding-left: 2px !important;
    padding-right: 2px !important;
  }

  /* Table header styling */
  ::v-deep .compact-table thead th {
    background-color: var(--v-primaryLighter-base) !important;
    color: var(--v-primaryDark-base) !important;
    font-weight: bold !important;
    border-right: none !important;
    border-bottom: 1px solid #D9D9D9 !important;
  }

  /* Text color for cells with plan active */
  ::v-deep .compact-table .cell-wrapper.plan-active input,
  ::v-deep .compact-table .cell-wrapper.plan-active .v-input input,
  ::v-deep .compact-table .cell-wrapper.plan-active .v-select__selection,
  ::v-deep .compact-table .cell-wrapper.plan-active .v-text-field__slot input {
    color: var(--v-primary-base) !important;
  }

  /* Color for select-plan dropdown arrow and clear icon */
  ::v-deep .select-plan .v-input__append-inner .v-icon,
  ::v-deep .select-plan .v-input__icon .v-icon {
    color: var(--v-primary-base) !important;
  }

  /* Style for plan edit icon (pencil) */
  .plan-edit-icon {
    background-color: #F9F6FE !important;
    border-radius: 4px !important;
    padding: 4px !important;
  }

  /* Remove underline from all text fields in table */
  ::v-deep .compact-table .v-text-field__slot::before,
  ::v-deep .compact-table .v-text-field__slot::after,
  ::v-deep .compact-table .v-text-field > .v-input__control > .v-input__slot::before,
  ::v-deep .compact-table .v-text-field > .v-input__control > .v-input__slot::after {
    border: none !important;
  }

  ::v-deep .compact-table .v-text-field .v-input__slot::before,
  ::v-deep .compact-table .v-text-field .v-input__slot::after {
    display: none !important;
  }

  /* Remove border-bottom from v-input inside table cells */
  ::v-deep .compact-table .v-data-table__wrapper td .v-input {
    border-bottom: none !important;
  }

  /* Center content in Cuenta column (first column) */
  ::v-deep .compact-table tbody tr td:nth-child(1) {
    vertical-align: middle !important;
  }

  ::v-deep .compact-table tbody tr td:nth-child(1) .v-input {
    display: flex !important;
    align-items: center !important;
  }

  ::v-deep .compact-table tbody tr td:nth-child(1) .v-input__control {
    display: flex !important;
    align-items: center !important;
  }

  ::v-deep .compact-table tbody tr td:nth-child(1) .v-input__slot {
    display: flex !important;
    align-items: center !important;
  }

  ::v-deep .compact-table tbody tr td {
    padding: 0 !important;
  }

  ::v-deep .compact-table tbody tr td:nth-child(3) .cell-wrapper,
  ::v-deep .compact-table tbody tr td:nth-child(4) .cell-wrapper,
  ::v-deep .compact-table tbody tr td:nth-child(5) .cell-wrapper,
  ::v-deep .compact-table tbody tr td:nth-child(6) .cell-wrapper,
  ::v-deep .compact-table tbody tr td:nth-child(7) .cell-wrapper {
    padding: 4px !important;
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }

  /* Make background color fill entire cell */
  ::v-deep .compact-table tbody tr td:nth-child(6) .select-plan,
  ::v-deep .compact-table tbody tr td:nth-child(7) .select-plan {
    height: 100% !important;
    display: flex !important;
    align-items: center !important;
  }

  ::v-deep .compact-table tbody tr td:nth-child(6) .select-plan .v-input__control,
  ::v-deep .compact-table tbody tr td:nth-child(7) .select-plan .v-input__control {
    height: 100% !important;
  }

  /* Hide scrollbar from modal container */
  .modal-container {
    scrollbar-width: none !important; /* Firefox */
    -ms-overflow-style: none !important; /* IE and Edge */
  }

  .modal-container::-webkit-scrollbar {
    display: none !important; /* Chrome, Safari, Opera */
  }
</style>

<style>
/* Hide scrollbar from vm--modal only when it contains modal-container */
.vm--modal:has(.modal-container) {
  scrollbar-width: none !important; /* Firefox */
  -ms-overflow-style: none !important; /* IE and Edge */
}

.vm--modal:has(.modal-container)::-webkit-scrollbar {
  display: none !important; /* Chrome, Safari, Opera */
}
</style>